<template>
  <div>
    <el-button type="success" size="mini" @click="checkCapital">查看流水</el-button>
    <el-dialog
      title="账户流水:"
      :visible.sync="dialogFormVisible"
      class="refund-dialog"
      width="55%">
      <ApeTable
        :columns="columns" height="550"
        :loading="loadingStaus"
        :pagingData="pagingData"
        :data="capitalFlowList"
      >
      </ApeTable>
    </el-dialog>
  </div>
</template>
<script>
import ApeTable from "../components/ApeTable";
export default {
  components: {
    ApeTable,
  },
  data() {
    return {
      dialogTableVisible: false,
      dialogFormVisible: false,
      loadingStaus: false,
      pagingData: {},
      capitalFlowList: [],
      //  查看流水数据
      LookData: [],
      columns: [
        {
          title: "编号",
          value: "id",
          width: 150,
          header_align: "center",
          align: "center",
        },
        {
          title: "交易金额",
          value: "money",
          width: 150,
          header_align: "center",
          align: "center",
        },

        {
          title: "出款账户",
          width: 200,
          header_align: "center",
          align: "center",
          value: "send_uid",
        },
        {
          title: "入款账户",
          width: 200,
          header_align: "center",
          align: "center",
          value: "collect_uid",
        },
        {
          title: "交易时间",
          width: 200,
          header_align: "center",
          align: "center",
          value: "updated_at",
        }
      ],
    };
  },
  methods: {
    checkCapital() {
      this.dialogFormVisible = true
      this.checkCapitalFlow()
    },
    async checkCapitalFlow() {
      const result = await this.$api.checkCapitalFlow({
        uid: this.$store.state.switchInfo.nowCompany.trade_uid
      })
      console.log("流水信息",result)
      this.capitalFlowList = result
    }
  }
};
</script>
<style scoped>
>>>.el-dialog {
  margin-top: 5vh!important;
  /*overflow: scroll;*/
  /*height: 800px;*/
}

.refund-dialog /deep/ .el-dialog .el-dialog__body{
   padding:30px 30px  !important;
}
.refund-dialog /deep/ .el-dialog .el-dialog__header span {
  display: inline-block;
  border-left: 5px solid #1890ff;
  padding-left: 10px;
  height: 24px;
  color: #101010;
}
.refund-dialog /deep/ .el-dialog .el-dialog__header {
  padding-bottom: 50px !important;
}
.refund-dialog /deep/ .el-dialog .el-dialog__body {
  padding-top: 0 !important;
}
</style>